/**
 * ver 0.1
 * author jspark
 * props
 * @props {integer} item 상품 고유번호
 * @props {object} miniShop
 *  위 두항목중 하나는 필수값
 * @props {string} cls button tag 클래스
 * @props {string} txt button tag 텍스트
 * @props {boolean} isM 모바일인지 여부 true / false
 * ex)
 <Report item={4916691} miniShop={{idx_b_manager:5009,mall_name:"행복쇼핑"}} isM={true} cls={"icon-notify"} txt={"신고하기"}/>
 */

import React from 'react'
import axios from 'axios'
import LoginLayer from 'estimate_list/components/layer/loginLayer'
import ReportLayer from 'estimate_list/components/layer/reportLayer'
import DefaultLayer from 'estimate_list/components/layer/defaultLayer'
import { getCookie } from 'estimate_list/libs/cookie'
class Report extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadOn: false,
            isOn: false,
            popOn: false,
            pMsgN: 0,
            item: {},
            claim: {},
        }
        let ment = '신고가 접수되었습니다.'
        this._url = `${process.env.REACT_APP_API_URL}/front/v2/`
        this.pMsg = ['대상정보를 불러오지 못했습니다.', ment, '신고중 오류가 발생하였습니다.']
        this._config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
    }
    showPop() {
        this.setState({ loadOn: true })
        const auth_token = getCookie('auth_token')
        axios
            .post(this._url + 'user/info', auth_token, this._config)
            .then(rsp => {
                if (rsp.data.isLogin) {
                    this.loadItem()
                } else {
                    this.setState({ logOn: true, loadOn: false })
                }
            })
            .catch(_err => {
                this.setState({ popOn: true, loadOn: false })
            })
    }

    loadItem() {
        let { miniShop, item } = this.props
        if (item) {
            let url = miniShop ? item + '/' + miniShop.idx_b_manager : item
            axios
                .post(this._url + 'item/view/' + url + '?from=report')
                .then(rsp => {
                    if (rsp.data.code === 200) {
                        this.loadClaim(1, rsp.data.result)
                    } else {
                        this.setState({ pMsgN: 0, popOn: true, loadOn: false })
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.setState({ pMsgN: 0, popOn: true, loadOn: false })
                })
        } else {
            this.loadClaim(2)
        }
    }

    loadClaim(tp, dt) {
        axios
            .post(this._url + 'board/claimType/' + tp)
            .then(rsp => {
                if (rsp.data.code === 200) {
                    this.setState({ isOn: true, item: dt, claim: rsp.data.data.ClaimType })
                    document.body.style.overflowY = 'hidden'
                    document.querySelector('#header').style.opacity = 0
                } else {
                    this.setState({ pMsgN: 0, popOn: true, loadOn: false })
                }
            })
            .catch(err => {
                console.log(err)
                this.setState({ pMsgN: 0, popOn: true, loadOn: false })
            })
    }

    goClaim(cn, msg) {
        let { miniShop, item } = this.props
        let _param = {
            idx_top_notify: cn,
            item_id: item,
            idx_b_manager_ref: miniShop.idx_b_manager,
            message: msg,
        }
        axios
            .post(this._url + 'board/claim/', _param, this._config)
            .then(rsp => {
                console.log(rsp, cn, msg)
                if (rsp.data.code === 200) {
                    this.setState({ pMsgN: 1, popOn: true, loadOn: false, isOn: false })
                } else {
                    this.setState({ pMsgN: 2, popOn: true, loadOn: false })
                }
            })
            .catch(err => {
                console.log(err)
                this.setState({ pMsgN: 2, popOn: true, loadOn: false })
            })
    }
    closePop() {
        this.setState({ logOn: false, isOn: false, popOn: false, loadOn: false })
        document.body.style.overflowY = 'auto'
        document.querySelector('#header').style.opacity = 1
    }
    render() {
        let { logOn, isOn, popOn, loadOn, item, claim, pMsgN } = this.state
        let { miniShop, cls, txt } = this.props
        return (
            <div className="reportWrap">
                {loadOn ? (
                    <img
                        className={cls + ' mknt'}
                        src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/loading_w.gif`}
                        alt="진행중"
                    />
                ) : (
                    <button className={cls + ' mknt'} onClick={() => this.showPop()}>
                        {txt}
                    </button>
                )}
                {logOn && <LoginLayer onClose={() => this.closePop()} />}
                {isOn && (
                    <ReportLayer
                        shop={miniShop}
                        data={item}
                        type={claim}
                        onClose={() => this.closePop()}
                        send={(cn, msg) => this.goClaim(cn, msg)}
                    />
                )}
                {popOn && <DefaultLayer children={<span>{this.pMsg[pMsgN]}</span>} onClose={() => this.closePop()} />}
            </div>
        )
    }
}

export default Report



// WEBPACK FOOTER //
// ./src/estimate_list/utils/report.js